export const dayVariationTime = 'day';
export const weekVariationTime = 'week';
export const monthVariationTime = 'month';
export const yearVariationTime = 'year';
